import { getCounties } from "./getCounties";
import { getMunicipalities } from "./getMunicipalities";
import { getCityForZipCode } from "./getCityForZipCode";

export const placesAPI = {
  getCityForZipCode,
  getMunicipalities,
  getCounties,
};

export type PlacesAPI = typeof placesAPI;
